import { actionNoun, actionTileTitle, type RequisitionAction } from '@utils/requisitionAction';

/**
 * What the dialog says before an action change throws the position away.
 *
 * It names the old action as a noun and quotes the new one by its tile title, so the customer
 * reads back the words they clicked rather than the wizard's internal verbs.
 */
export function actionSwitchMessage(
    positionCount: number,
    action: RequisitionAction | undefined,
    pendingAction: RequisitionAction | undefined,
): string {
    const isSingle = positionCount === 1;

    return [
        `Du hast ${positionCount} ${isSingle ? 'Position' : 'Positionen'} für ${actionNoun(action)} erfasst.`,
        `Wenn du zu „${actionTileTitle(pendingAction)}“ wechselst, ${
            isSingle ? 'wird sie verworfen' : 'werden sie verworfen'
        }.`,
    ].join(' ');
}

/**
 * What the dialog says before the site changes under an entered position.
 *
 * A container stands at a site; moving the order elsewhere leaves the position pointing at
 * nothing, so it goes with it.
 */
export function siteSwitchMessage(positionCount: number): string {
    const isSingle = positionCount === 1;

    return [
        `Du hast ${positionCount} ${isSingle ? 'Position' : 'Positionen'} erfasst.`,
        `Wenn du den Leistungsort wechselst, ${isSingle ? 'wird sie verworfen' : 'werden sie verworfen'}.`,
    ].join(' ');
}
